import React, { useEffect, useRef, useState } from "react";
import { PropTypes } from "prop-types";
import { useLocation, useParams } from "react-router-dom";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
//reducer
import * as actions from "./actions.js";
//components
import PageNotFound from "../../../../common/PageNotFound/index.js";
import Spinner from "../../../../common/Spinner/index.js";
import AppHoc from "../../../../generics/AppHOC/index.js";
import ErrorComponent from "../../../../common/ErrorComponent/index.js";
import TopClientsReport from "../../../clients/TopClientsReport";
import TimeStamp from "../../../../generics/TimeStamp/index.js";

//utils
import { getReportsHeader, getSiteId, getSiteName } from "../../../../../src/utils/common";
//style
import css from "../../reportsMagneticStyle.less";
import {
  shortDisplayDate24HourWithSec,
  formatDate,
} from "../../../../utils/displayTime.js";
import { timeFilterTypesCustomV4, isSpecificSiteSelection } from "../../../../utils/enums.js";
import apiService from "../../../../config/api-config";
import { useMount } from "../../../../utils/genericCommon";
import { useI18n } from "../../../../i18n/useI18n";

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const mapStateToProps = (state) => {
  return {
    topClientsReport: state.vanalytics.topClientsReport,
  };
};

const TopClients = (props) => {
  const { tViews } = useI18n('views');
  const envVarForReports = process.env.REACT_APP_SKIP_RBAC_DISABLE_RBAC;
  const { id: reportId } = useParams();
  const location = useLocation();
  const [topClientsTableCallback, setTopClientsTableCallback] = useState(false);
  const [top10BarChartCallback, setTop10BarChartCallback] = useState(false);
  const [siteInfoData, setSiteInfoData] = useState(tViews('reportTemplatesSites'));
  const previewRef = useRef(null);
  const mount = useMount();

  useEffect(() => {
    const { getReportData } = props.actions;
    getReportData(reportId);
  }, []);

  const setSiteID = async (selectedSiteId) => {
    if (
        isSpecificSiteSelection(selectedSiteId) &&
        mount.initMount
    ) {
      mount.initMount = false;
      const sitesResult = await apiService.getSites();
      if (sitesResult?.data?.data?.length > 0) {
        const siteInfo = sitesResult.data.data;
        const siteData = getSiteName('report', siteInfo, selectedSiteId);
        setSiteInfoData(siteData);
      } else {
        setSiteInfoData(tViews('reportTemplatesSites'));
      }
    }
  }

  useEffect(() => {
    if (
      previewRef.current &&
      topClientsTableCallback &&
      top10BarChartCallback
    ) {
      previewRef.current.id = "isLoaded_chart";
    }
  }, [props.topClientsReport, topClientsTableCallback, top10BarChartCallback]);

  // Callbacks from donut components to indicate data is available for report generation
  const isTopClientsTableCallback = (data) => {
    setTopClientsTableCallback(data);
  };
  // // Callbacks from top20 components to indicate data is available for report generation
  const isTop10BarChartCallback = (data) => {
    setTop10BarChartCallback(data);
  };

  if (props.topClientsReport.reportLoader) {
    return <Spinner />;
  } else if (props.topClientsReport.errorReportData) {
    return (
      <ErrorComponent
        {...props.topClientsReport.errorMessage}
        width={"210px"}
        className={"small-dashlet-error"}
      />
    );
  } else if (props.topClientsReport.reportData.data.length > 0) {
    const reportData = props.topClientsReport.reportData.data[0];
    const {
      current_period_start,
      current_period_end,
      time_range
    } = reportData;

    // siteid converted to numbers, if site_id coming as numbers string seperated by comma e,g ["1,2"] -> [1,2]
    const site_id = getSiteId(reportData);
    let globalV4PayloadReport = {
      time_frame: timeFilterTypesCustomV4[time_range],
      entry_ts: {
        start: shortDisplayDate24HourWithSec(
          formatDate(current_period_start).utc()
        ),
        end: shortDisplayDate24HourWithSec(
          formatDate(current_period_end).utc()
        ),
      },
    };
    setSiteID(site_id);
    // when site_id is not all, then only pass site_id to payload
    if (isSpecificSiteSelection(site_id)) {
      globalV4PayloadReport["site_id"] = site_id;
    }
    //by default is_debug is false and report browser link is disable/block to show reports
    if (envVarForReports === "FALSE") {
      if (reportData && !reportData?.is_debug) {
        return <PageNotFound />;
      }
    }

    return (
      <div className={css["top-clients-report"]} ref={previewRef}>
        {getReportsHeader(reportData.overlay_name, location)}
        <div className="all-clients-scope-section">
          <span className="details">
            <span className="title hbr-type-body3">{tViews('sitesLabel')}</span>
            <span className="value hbr-type-body3">{siteInfoData}</span>
          </span>
          <TimeStamp {...props} isReport={true} reportData={reportData} />
        </div>

        <TopClientsReport
          {...props}
          globalV4PayloadReport={globalV4PayloadReport}
          isTopClientsTableCallback={isTopClientsTableCallback}
          isTop10BarChartCallback={isTop10BarChartCallback}
        ></TopClientsReport>
      </div>
    );
  } else {
    return <PageNotFound />;
  }
};

TopClients.propTypes = {
  topClientsReport: PropTypes.object.isRequired,
  actions: PropTypes.object
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHoc(TopClients))
);
